import { permissions } from '~/shared/constants/permissions';

import { IResale } from '~/modules/resales/interfaces/IResale';
import { IUserAccess } from '~/modules/auth/interfaces/IUserAccess';

import { validateUserPermission } from './validateUserPermission';

export function checkPermissions(
  currentAccess: IUserAccess,
  resale: IResale
): typeof permissions {
  return Object.assign(
    {},
    ...Object.entries(permissions).map(([key, permissionObj]) => ({
      [key]: Object.assign(
        {},
        ...Object.entries(permissionObj).map(
          ([permissionKey, _permission]) => ({
            [permissionKey]: validateUserPermission({
              currentAccess,
              resale,
              permission: _permission,
            })
              ? _permission
              : undefined,
          })
        )
      ),
    }))
  );
}
